import object from 'helpers/object'


export const initialState = {
  data: {
    orders: [],
    total: null,
    totalPositions: [],
  },
  classes: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setData = (state, payload) => (
  object.setIn(state, [ 'data' ], payload)
)

export const setClasses = (state, payload) => (
  object.setIn(state, [ 'classes' ], payload)
)
